import { ParamMap } from '@angular/router'

export function somethingInTheRouteChanged(
  oldQueryParams: ParamMap,
  queryParams: ParamMap,
  oldParams: ParamMap,
  params: ParamMap,
  oldRouteUrl: string | undefined,
  routeUrl: string | undefined
): boolean {
  return (
    oldQueryParams.get('search') !== queryParams.get('search') ||
    oldQueryParams.get('facets') !== queryParams.get('facets') ||
    oldQueryParams.get('tournamentId') !== queryParams.get('tournamentId') ||
    oldParams.get('slug') !== params.get('slug') ||
    oldQueryParams.get('resultId') !== queryParams.get('resultId') ||
    removeQueryParamsFromUrl(oldRouteUrl) !== removeQueryParamsFromUrl(routeUrl)
  )
}

/**
 * We know if it's the same event hub if the slug exists and is the same.
 * This is important for determining whether to make an api request for partial or layout.
 * @param oldParams The previous route params.
 * @param params The current route params.
 * @returns true if the event hub is the same.
 */
export function isSameEventHub(oldParams: ParamMap, params: ParamMap) {
  return !!params?.get('slug') && oldParams?.get('slug') === params?.get('slug')
}

/**
 * Vanity urls have singular tabs, but BFF endpoints have different naming convention.
 * @param tab The vanity url tab name.
 * @returns The BFF endpoint tab param.
 */
export function getEventHubTab(url: string | undefined) {
  const urlSegments = removeQueryParamsFromUrl(url)?.split('/')
  if (urlSegments && urlSegments.length > 3) {
    const tab = urlSegments[3]
    if (!tab) return null
    switch (tab) {
      case 'events':
        return 'schedule'
      case 'results':
        if (urlSegments[4] === 'view-all') return 'results/list'
        return 'results'
      default:
        return tab
    }
  }

  return null
}

function removeQueryParamsFromUrl(url: string | undefined) {
  if (url?.includes('?')) {
    return url.split('?')[0]
  }

  return url
}
